// Notification.jsx
import React from "react";
import styles from "./Notification.module.css";

const Notification = ({ type, title, message, onClose, show }) => {
  if (!show) return null;

  const icons = {
    success: "✓",
    error: "✗",
    warning: "⚠",
    info: "ⓘ"
  };

  return (
    <div className={styles.notification}>
      <div className={`${styles['notification-box']} ${styles[`notification-${type}`]}`}>
        <div className={styles['notification-icon']}>
          {icons[type] || icons.info}
        </div>
        <div className={styles['notification-text']}>
          <h4>{title}</h4>
          <p>{message}</p>
        </div>
        <button 
          className={styles['notification-close']}
          onClick={onClose}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Notification;